var _rect, _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4698 32.7734H54.2048H54.2056C54.9285 32.7736 55.7714 32.7738 56.3976 33.5566L59.6868 39.2732C59.7651 39.3776 59.9374 39.7274 60 40.2913V46.2431C59.9478 46.6347 59.6554 47.4648 58.9036 47.6528H28.4396C28.0741 47.5223 27.3745 47.0889 27.4998 46.3998V42.719C27.3954 39.4038 27.2492 32.7734 27.4998 32.7734H47.4698ZM50.2291 35.2032V40.2152H57.6689L54.5364 35.2032H50.2291Z",
    fill: "#F2453D"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.8195,
    cy: 47.5794,
    rx: 3.75906,
    ry: 3.75906,
    fill: "#465A64"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.8192,
    cy: 47.5772,
    rx: 1.25302,
    ry: 1.25302,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.1085,
    cy: 47.5794,
    rx: 3.75906,
    ry: 3.75906,
    fill: "#465A64"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.1087,
    cy: 47.5772,
    rx: 1.25302,
    ry: 1.25302,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4097 42.5893C47.6603 42.2134 47.5141 33.6615 47.4097 29.4326C47.2792 28.9627 46.7519 28.023 45.6868 28.023H28.6144C28.2228 27.9446 27.424 28.023 27.3614 28.9627V30.2943V30.5287H21.253C20.561 30.5287 20 31.0897 20 31.7817C20 32.4737 20.561 33.0347 21.253 33.0347H27.3614V35.2058H23.1325C22.4405 35.2058 21.8795 35.7668 21.8795 36.4588C21.8795 37.1508 22.4405 37.7118 23.1325 37.7118H27.3614V40.06H24.3856C23.6936 40.06 23.1326 40.621 23.1326 41.313C23.1326 42.005 23.6936 42.566 24.3856 42.566H27.3614V42.5893H47.4097Z",
    fill: "#FEC02F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3552 35.1261C40.4323 35.0472 40.5375 35.002 40.6478 35.0006C40.7581 34.9992 40.8645 35.0416 40.9436 35.1185L43.3328 37.447C43.4118 37.5241 43.4569 37.6293 43.4584 37.7396C43.4598 37.8499 43.4174 37.9563 43.3404 38.0354L41.0119 40.4246C40.9339 40.4992 40.83 40.5405 40.7222 40.54C40.6143 40.5396 40.5108 40.4973 40.4334 40.4221C40.3563 40.3467 40.3114 40.2443 40.3081 40.1365C40.3049 40.0287 40.3435 39.9238 40.416 39.8439L42.0432 38.1742L35.2155 38.2274C35.1051 38.2288 34.9986 38.1863 34.9196 38.1093C34.8405 38.0322 34.7953 37.9269 34.7938 37.8165C34.7924 37.7061 34.8349 37.5997 34.912 37.5206C34.989 37.4415 35.0943 37.3963 35.2047 37.3949L42.0325 37.3417L40.3628 35.7145C40.2838 35.6374 40.2387 35.5322 40.2373 35.4219C40.2358 35.3115 40.2783 35.2052 40.3552 35.1261Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1991 29.7277C35.1221 29.6487 35.0168 29.6036 34.9065 29.6022C34.7962 29.6007 34.6898 29.6432 34.6108 29.7201L32.2215 32.0486C32.1425 32.1256 32.0974 32.2309 32.096 32.3412C32.0945 32.4515 32.137 32.5579 32.2139 32.6369L34.5424 35.0262C34.6204 35.1007 34.7243 35.1421 34.8321 35.1416C34.94 35.1411 35.0435 35.0989 35.1209 35.0237C35.198 34.9483 35.243 34.8459 35.2462 34.7381C35.2495 34.6303 35.2108 34.5254 35.1383 34.4455L33.5111 32.7758L40.3389 32.829C40.4493 32.8304 40.5557 32.7879 40.6348 32.7108C40.7138 32.6338 40.7591 32.5285 40.7605 32.4181C40.7619 32.3077 40.7194 32.2012 40.6424 32.1221C40.5653 32.0431 40.46 31.9979 40.3496 31.9964L33.5218 31.9432L35.1915 30.316C35.2705 30.239 35.3156 30.1337 35.3171 30.0234C35.3185 29.9131 35.2761 29.8067 35.1991 29.7277Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckin);
export default __webpack_public_path__ + "static/media/checkin.34f945ec2cb611aca8fd7acc40c2af38.svg";
export { ForwardRef as ReactComponent };